import { createContext, useEffect, useState } from 'react';
import type { FC } from 'react';
import { AlertColor } from '@mui/material';
import { ContextProviderProps } from 'src/types/contextProviderProps';

export interface ISnackbarContext {
  isSnackActive: boolean;
  snackMessage: React.ReactNode;
  snackSeverity: AlertColor;
  snackTimeout: number;
  openSnackBar: (msg: string | React.ReactNode, severity?: AlertColor, timeout?: number) => void;
  closeSnackBar: () => void;
}

const SnackbarContext = createContext<ISnackbarContext>({
  isSnackActive: false,
  snackMessage: '',
  snackSeverity: 'success',
  snackTimeout: 3000,
  openSnackBar: () => {},
  closeSnackBar: () => {},
});

export const SnackbarProvider: FC<ContextProviderProps> = ({ children }) => {
  const [isSnackActive, setIsSnackActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState<React.ReactNode>('');
  const [snackSeverity, setSnackSeverity] = useState<AlertColor>('success');
  const [snackTimeout, setSnackTimeout] = useState<number>(3000);

  useEffect(() => {
    if (isSnackActive === true) {
      setTimeout(() => {
        setIsSnackActive(false);
      }, snackTimeout);
    }
  }, [isSnackActive, snackTimeout]);

  const openSnackBar = (msg: string | React.ReactNode, severity: AlertColor = 'success', timeout: number = 3000) => {
    console.log('openSnackBar', msg, severity, timeout);
    setSnackMessage(msg);
    setSnackSeverity(severity);
    setSnackTimeout(timeout);
    setIsSnackActive(true);
  };

  const closeSnackBar = () => {
    console.log('closeSnackBar');
    setIsSnackActive(false);
  };

  const contextValue = {
    isSnackActive,
    snackMessage,
    snackSeverity,
    snackTimeout,
    openSnackBar,
    closeSnackBar,
  };

  return <SnackbarContext.Provider value={contextValue}>{children}</SnackbarContext.Provider>;
};

export const SnackbarConsumer = SnackbarContext.Consumer;

export default SnackbarContext;
